import { TwilioState } from '../interfaces/twilio';
import twilioCRUDActions from '../actions/TwilioCRUDActions';

const initialState: TwilioState = {
  numbers: [],
  testNumbers: [],
  countryAreaCodes: [],
  numbersToSelect: [],
  callForwardingNumber: '',
  busy: false,
};

type GetAllNumbersAction = ReturnType<
  typeof twilioCRUDActions.getAllNumbersActionCreator
>;

type SetCountryAreaCodesAction = ReturnType<
  typeof twilioCRUDActions.getCountryCodesActionCreator
>;

const setBusy = (state: TwilioState) => {
  return {
    ...state,
    busy: true,
  };
};

const setUnbusy = (state: TwilioState) => {
  return {
    ...state,
    busy: false,
  };
};

const getAllNumbers = (
  state: TwilioState,
  { numbers, testNumbers, callForwardingNumber }: GetAllNumbersAction,
) => {
  return {
    ...state,
    numbers,
    testNumbers,
    callForwardingNumber,
  };
};

const getNumbersToSelect = (
  state: TwilioState,
  { numbers }: GetAllNumbersAction,
) => {
  return {
    ...state,
    numbersToSelect: numbers,
  };
};

const getCountryCodes = (
  state: TwilioState,
  { codes }: SetCountryAreaCodesAction,
) => {
  return {
    ...state,
    countryAreaCodes: codes,
  };
};

const clearNumbers = (state: TwilioState) => ({
  ...state,
  numbersToSelect: [],
});

const resetTwilio = (state: TwilioState) => ({
  ...state,
  ...initialState,
});

const updateTwilio = (
  state: TwilioState,
  action: ReturnType<typeof twilioCRUDActions.updateSuccessActionCreator>,
) => ({
  ...state,
  testNumbers: action.testNumbers,
  callForwardingNumber: action.callForwardingNumber,
});

const twilio = (state = initialState, action: any) => {
  switch (action.type) {
    case twilioCRUDActions.busyAction:
      return setBusy(state);
    case twilioCRUDActions.getAllNumbersAction:
      return getAllNumbers(state, action);
    case twilioCRUDActions.setCountryAreaCodesAction:
      return getCountryCodes(state, action);
    case twilioCRUDActions.setAvailableNumberAction:
      return getNumbersToSelect(state, action);
    case twilioCRUDActions.unbusyAction: {
      return setUnbusy(state);
    }
    case twilioCRUDActions.clearAvailableNumbersAction: {
      return clearNumbers(state);
    }
    case twilioCRUDActions.resetTwilioAction: {
      return resetTwilio(state);
    }
    case twilioCRUDActions.updateActionSuccess:
      return updateTwilio(state, action);
    default:
      return state;
  }
};

export default twilio;
